<mat-card class="alert" [ngClass]="type">
  <mat-icon class="material-symbols-outlined">{{ type }}</mat-icon>
  <p>{{ message }}</p>
  <button *ngIf="displayCloseButton" mat-icon-button (click)="closed.emit()">
    <mat-icon class="material-symbols-outlined">close</mat-icon>
  </button>
</mat-card>
